import { IUser } from '@giphy/js-types'
import { Avatar, Container, SearchButton, Username } from './style'

type Props = {
    className?: string
    user: IUser
    onSearch?: (searchTerm?: string) => void
}

const UgeLayerContextMenuAttribution = ({ className, user, onSearch }: Props) => {
    const onSearchClick = () => {
        onSearch?.(`@${user.username}`)
    }

    return (
        <Container className={className}>
            <Avatar user={user} />
            <Username>
                <span>See more by </span>
                <h3>{user.display_name || `@${user.username}`}</h3>
            </Username>
            <SearchButton gradient="red-pink" icon="search" inverted size="small" onClick={onSearchClick} />
        </Container>
    )
}

export default UgeLayerContextMenuAttribution
